import Vue from 'vue'
import Vuex from 'vuex'
import account from './modules/account'
import setting from './modules/setting'
import common from './modules/common'
import dict from './modules/dict'
import baseinfo from "./modules/baseinfo"

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    account,
    setting,
    dict,
    baseinfo,
    common
  }
})
